import { Injectable } from '@angular/core';
import {
  Address,
  LoadChangeRequestsQuery,
  LoadPendingChangeRequestsCountQuery,
  UpdateCertificationChangeRequestInput,
  UpdateCertificationChangeRequestMutation
} from '@queries/generated';
import { finalMap } from '@rx/final-map';
import { omit } from '@util/omit';
import equal from 'fast-deep-equal';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CertificationChangeRequestService {
  list$ = this.loadChangeRequestsQuery
    .watch()
    .valueChanges.pipe(map(({ data }) => data.certificationChangeRequests.all.nodes));

  count$ = this.loadPendingChangeRequestsCountQuery
    .watch()
    .valueChanges.pipe(map(({ data }) => data.certificationChangeRequests.all.count));

  constructor(
    private loadChangeRequestsQuery: LoadChangeRequestsQuery,
    private loadPendingChangeRequestsCountQuery: LoadPendingChangeRequestsCountQuery,
    private updateCertificationChangeRequestMutation: UpdateCertificationChangeRequestMutation
  ) {}

  update(input: UpdateCertificationChangeRequestInput) {
    return this.updateCertificationChangeRequestMutation
      .mutate({ input }, { refetchQueries: ['LoadChangeRequests'] })
      .pipe(
        map(({ data }) => data.updateCertificationChangeRequest),
        finalMap('certificationChangeRequest')
      );
  }

  hasAddressPersisted(address1: Address, address2: Address) {
    if (!address1) {
      return true;
    }

    const omittedKeys: Array<keyof Address> = ['__typename', 'id', 'gid'];

    const a = omit(address1, ...omittedKeys);
    const b = omit(address2, ...omittedKeys);

    return equal(a, b);
  }
}
